/**
 * Users/Index Controller
 *
 * 
 */
 
 // the constructor for this object
 function UsersUpdateProfileController() { }
 
// the object
UsersUpdateProfileController.prototype = {
    constructor: UsersUpdateProfileController,
    
    // the secret key acquired from api to enable two factor authentication
    twoFactorSecret: null,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        PortalHelper.debugMessage('Edit User Controller Initialized');
    },

    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        this._registerTabs();
        this._getUserInfo();
        
        PortalHelper.debugMessage('Edit User Controller Ran');
    },

    // register the javascript events
    _registerEvents:  function() 
    {   
        var self = this;
        
        $('#user-profile-form').on('submit', function(e) {
            e.preventDefault();
            
            self._updateUserProfile();
        });
        
        $('#user-password-form').on('submit', function(e) {
            e.preventDefault();
            
            self._updateUserPassword();
        });
        
        $('#two-factor-get-started-button').on('click', function(e) {
            e.preventDefault();
            
            self._getTwoFactorSecret();
        });
        
        $('#two-factor-enable-button').on('click', function(e) {
            e.preventDefault();
            
            self._enableTwoFactor();
        });
        
        $('#two-factor-disable-button').on('click', function(e) {
            e.preventDefault();
            
            self._disableTwoFactor();
        });
    },
    
    
    
    // setup or remove the tabs
    _registerTabs: function(ebInfo)
    {
        var buttonTabs = new PortalButtonTabs;
        buttonTabs.init('.button-tabs');
    },
    
    /*
        Utilizes the API to bring in info for the user we're currently editing.
        Calls populateTable to put all of that info into our table
    */
    _getUserInfo: function()
    {
        $('.form').addClass('loading');
        var self = this;
        var userInfoRequest = new PortalRequest;
        userInfoRequest.errorElement = '#user-profile-form .form-errors';
        userInfoRequest.makeRequest(
            '/users/get-authenticated-user',
            {},
            function(response) {
                
                PortalHelper.enableButton('#update-user-profile');
                PortalHelper.enableButton('#update-user-password');
                
                self._populateProfileForm(response);
                self._populateTwoFactor(response);
                
                PortalHelper.loadingOverlay('#user-profile-form', false);
                PortalHelper.loadingOverlay('#user-password-form', false);
            },
            function() {
                $('.form').addClass('hidden');
                $('.form-errors').append('<br> Redirecting...');
                setTimeout(function () {
                    window.location.href = PortalConfig.portalUrl + '/users/';
                }, 3000);   
                PortalHelper.loadingOverlay('#user-form', false);
            }
        )
    },
    
    /*
        Populates the table with the information of the user we're editing
    */
    _populateProfileForm: function(response)
    {
        var email = PortalHelper.htmlspecialcharsDecode(response.email_nm);
        $('#user-profile-form .email').val(email);
        
        var firstName = PortalHelper.htmlspecialcharsDecode(response.first_nm);
        $('#user-profile-form .first-name').val(firstName);
        
        var lastName = PortalHelper.htmlspecialcharsDecode(response.last_nm);
        $('#user-profile-form .last-name').val(lastName);
    },
    
    /*
        Calls the API to update the user's information, including account access
    */
    _updateUserProfile: function()
    {
        PortalHelper.loadingOverlay('#user-profile-form', true);
        PortalHelper.disableButton('#update-user-profile');
        
        var updateUserProfileRequest = new PortalRequest();
        updateUserProfileRequest.successElement = '#user-profile-form .form-success';
        updateUserProfileRequest.errorElement = '#user-profile-form .form-errors';
        updateUserProfileRequest.makeRequest(
            '/users/update-profile',
            {
                email_nm: $('#user-profile-form .email').val(),
                first_nm: $('#user-profile-form .first-name').val(),
                last_nm: $('#user-profile-form .last-name').val(),
                passwd: $('#user-profile-form .current-password').val(),
            },
            function(response) {
                PortalHelper.enableButton('#update-user-profile');
                PortalHelper.loadingOverlay('#user-profile-form', false);              
            },
            function(response) {
                PortalHelper.enableButton('#update-user-profile');
                PortalHelper.loadingOverlay('#user-profile-form', false);  
            }
        );
    },
    
    /*
        Calls the API to update the user's password
    */
    _updateUserPassword: function()
    {
        PortalHelper.loadingOverlay('#user-password-form', true);
        PortalHelper.disableButton('#update-user-password');
        
        var updateUserPasswordRequest = new PortalRequest();
        updateUserPasswordRequest.successElement = '#user-password-form .form-success';
        updateUserPasswordRequest.errorElement = '#user-password-form .form-errors';
        updateUserPasswordRequest.makeRequest(
            '/users/update-password',
            {
                current_password: $('#user-password-form .current-password').val(),
                passwd: $('#user-password-form .new-password').val(),
                confirm: $('#user-password-form .confirm-password').val(),
            },
            function(response) {
                PortalHelper.enableButton('#update-user-password');
                PortalHelper.loadingOverlay('#user-password-form', false);              
            },
            function(response) {
                PortalHelper.enableButton('#update-user-password');
                PortalHelper.loadingOverlay('#user-password-form', false);  
            }
        );
    },
    
    /*
        Populates the proper display for two factor authentication
    */
    _populateTwoFactor: function(response)
    {
        var twoFactorEnabled = response.two_factor_enabled;
        
        if (twoFactorEnabled) {
            $('#two-factor-get-started').addClass('hidden');
            $('#two-factor-enable').addClass('hidden');
            $('#two-factor-disable').removeClass('hidden');
            
            PortalHelper.enableButton('#two-factor-disable-button');
            
        } else {
            $('#two-factor-get-started').removeClass('hidden');
            $('#two-factor-enable').addClass('hidden');
            $('#two-factor-disable').addClass('hidden');
            
            PortalHelper.enableButton('#two-factor-get-started-button');
        }
        
        PortalHelper.loadingOverlay('#user-two-factor-form', false);  
    },
    
    // acquire a two factor secret key
    _getTwoFactorSecret: function()
    {
        $('#user-two-factor-form').addClass('loading');
        PortalHelper.disableButton('#two-factor-get-started-button');
        
        var self = this;
        var twoFactorSecretRequest = new PortalRequest;
        twoFactorSecretRequest.makeRequest(
            '/users/get-two-factor-authentication-secret',
            {},
            function(response) {
        
                self._fillTwoFactorSecret(response);
                
                $('#two-factor-form .form-errors').addClass('hidden');
                $('#two-factor-form .form-success').addClass('hidden');
                
                $('#two-factor-get-started').addClass('hidden');
                $('#two-factor-enable').removeClass('hidden');
                $('#two-factor-disable').addClass('hidden');
                
                PortalHelper.loadingOverlay('#user-two-factor-form', false);
                
                PortalHelper.enableButton('#two-factor-enable-button');
            }
        )
    },
    
    // populate the two factor info
    _fillTwoFactorSecret: function(response)
    {
        PortalMain.UsersUpdateProfileController.twoFactorSecret = response.key;
        
        var qr = response.qr;
        $('.qr-code img').attr('src', qr);
        $('#two-factor-enable .secret-key').html(response.key);
    },
    
    // send the secret key to enable two factor
    _enableTwoFactor: function()
    {
        $('#user-two-factor-form').addClass('loading');
        PortalHelper.disableButton('#two-factor-enable-button');
    
        var self = this;
        var twoFactorEnableRequest = new PortalRequest;
        twoFactorEnableRequest.errorElement = '#user-two-factor .form-errors';
        twoFactorEnableRequest.successElement = '#user-two-factor .form-success';
        twoFactorEnableRequest.makeRequest(
            '/users/activate-two-factor-authentication-secret',
            {
                passcode: $('#two-factor-enable input[name=passcode]').val(),
                secretKey: PortalMain.UsersUpdateProfileController.twoFactorSecret 
            },
            function(response) {
                $('#two-factor-get-started').addClass('hidden');
                $('#two-factor-enable').addClass('hidden');
                $('#two-factor-disable').addClass('hidden');
                $('#two-factor-success').removeClass('hidden');
                
                $('#two-factor-form .form-errors').addClass('hidden');
                
                PortalHelper.loadingOverlay('#user-two-factor-form', false);
                PortalHelper.enableButton('#two-factor-disable-button');
                
            },
            function(response) {
                PortalHelper.loadingOverlay('#user-two-factor-form', false);
                PortalHelper.enableButton('#two-factor-enable-button'); 
            }
        )
    },
    
    // acquire a two factor secret key
    _disableTwoFactor: function()
    {
        $('#user-two-factor-form').addClass('loading');
        PortalHelper.disableButton('#two-factor-disable-button');
        
        var self = this;
        var twoFactorDisableRequest = new PortalRequest;
        twoFactorDisableRequest.errorElement = '#user-two-factor .form-errors';
        twoFactorDisableRequest.successElement = '#user-two-factor .form-success';
        twoFactorDisableRequest.makeRequest(
            '/users/disable-two-factor-authentication',
            {
                currentPassword: $('#two-factor-disable input[name=current-password]').val()
            },
            function(response) {
                
                $('#two-factor-get-started').removeClass('hidden');
                $('#two-factor-enable').addClass('hidden');
                $('#two-factor-disable').addClass('hidden');
                
                $('#two-factor-form .form-errors').addClass('hidden');
                
                PortalHelper.loadingOverlay('#user-two-factor-form', false);
                
                PortalHelper.enableButton('#two-factor-get-started-button');
            },
            function(response) {
                PortalHelper.loadingOverlay('#user-two-factor-form', false);
                PortalHelper.enableButton('#two-factor-disable-button'); 
            }
        )
    },
 }